import { middleware } from './middleware';
import { staticReducers } from './staticReducers';
import { ReducerService } from 'js/services/reducer.service';
import { createStore, applyMiddleware, compose } from 'redux';

const reducerService = new ReducerService<typeof staticReducers>(staticReducers);

const store = createStore(reducerService.combinedReducer, compose(applyMiddleware(...middleware)));

export {
    store,
    reducerService
};
